import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-269b2d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submitView" }
const _hoisted_2 = { class: "mainTitle withArrow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-L icon" }, null, -1))
const _hoisted_4 = { class: "wp550 feedBack" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "feedbackInfo" }
const _hoisted_7 = { class: "img" }
const _hoisted_8 = { class: "all-images" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "hover-icon icon-warpit_icon_trash" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_plus" }, null, -1))
const _hoisted_13 = { class: "p-float-label error-label" }
const _hoisted_14 = { for: "title" }
const _hoisted_15 = { class: "p-float-label error-label" }
const _hoisted_16 = { for: "time" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_clock icon" }, null, -1))
const _hoisted_18 = { class: "p-float-label error-label" }
const _hoisted_19 = { for: "address" }
const _hoisted_20 = ["aria-label"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_close_small" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "feedbackDisclaimer" }
const _hoisted_24 = { class: "map" }
const _hoisted_25 = { class: "p-float-label error-label" }
const _hoisted_26 = { for: "category" }
const _hoisted_27 = { class: "p-float-label error-label" }
const _hoisted_28 = { for: "local_community" }
const _hoisted_29 = { class: "p-float-label error-label" }
const _hoisted_30 = { for: "description" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1))
const _hoisted_33 = { class: "verificationStatus" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1))
const _hoisted_35 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "arrowBack",
        to: { name: 'FeedbackDashboard' }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(_toDisplayString(_ctx.$t("tell_city_view.submit_notification")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("feedback.notice")), 1)
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("feedback.select_image")), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedImages, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "selected-images",
                  onClick: ($event: any) => (_ctx.removeImage(index))
                }, [
                  _createElementVNode("img", {
                    src: image,
                    alt: ""
                  }, null, 8, _hoisted_10),
                  _hoisted_11
                ], 8, _hoisted_9))
              }), 128)),
              (_ctx.selectedImages.length < 4)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "image-selector",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addImage && _ctx.addImage(...args)))
                  }, [
                    _hoisted_12,
                    _createElementVNode("input", {
                      ref: "imageUpload",
                      id: "imageUploadId",
                      "hide-input": "",
                      accept: "image/*",
                      style: {"display":"none"},
                      type: "file",
                      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
                    }, null, 544)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_InputText, {
                id: "title",
                type: "text",
                modelValue: _ctx.form.title,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                name: "title",
                maxlength: "65",
                onFocusout: _ctx.onTitleFocusOut
              }, null, 8, ["modelValue", "onFocusout"]),
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("feedback.subject")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.title), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_15, [
              _createVNode(_component_Calendar, {
                id: "time",
                modelValue: _ctx.form.time,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.time) = $event)),
                showTime: true,
                showSeconds: true,
                dateFormat: "dd.mm.yy",
                panelClass: "addZindex"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("feedback.time")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.time), 1)
            ]),
            _hoisted_17
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_18, [
              _createVNode(_component_GMapAutocomplete, {
                class: _normalizeClass({
                  'autocomplete pac-target-input': !_ctx.form.address,
                  'autocomplete pac-target-input p-filled': _ctx.form.address,
                }),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.address = $event.target.value)),
                onPlace_changed: _ctx.setAddress,
                options: {
                  componentRestrictions: { country: 'si' },
                },
                value: _ctx.form.address,
                placeholder: "",
                id: "address",
                maxlength: "255"
              }, null, 8, ["class", "onPlace_changed", "value"]),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.address), 1),
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("feedback.location")), 1)
            ]),
            (_ctx.form.address)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "unstyled-button icon",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeLocation && _ctx.removeLocation(...args))),
                  "aria-label": _ctx.$t('feedback.clear_address')
                }, _hoisted_22, 8, _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("feedback.disclaimer")), 1)
          ]),
          _createElementVNode("li", _hoisted_24, [
            _createVNode(_component_GMapMap, {
              zoom: 15,
              center: _ctx.center,
              onClick: _ctx.handleMapClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_GMapMarker, {
                  position: _ctx.marker.position
                }, null, 8, ["position"])
              ]),
              _: 1
            }, 8, ["center", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_Dropdown, {
                id: "category",
                modelValue: _ctx.form.type_id,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.type_id) = $event)),
                options: _ctx.types,
                optionLabel: "name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.type_id), 1),
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("feedback.category")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_27, [
              _createVNode(_component_Dropdown, {
                id: "local_community",
                modelValue: _ctx.form.local_community_id,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.local_community_id) = $event)),
                options: _ctx.localCommunities,
                optionLabel: "name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.something_wrong), 1),
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("feedback.local_community")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_29, [
              _createVNode(_component_Textarea, {
                modelValue: _ctx.form.description,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.description) = $event)),
                id: "description",
                maxlength: "1500",
                onFocusout: _ctx.onDescriptionFocusOut
              }, null, 8, ["modelValue", "onFocusout"]),
              _createElementVNode("p", null, _toDisplayString(_ctx.errors.description), 1),
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("feedback.description")), 1)
            ])
          ]),
          (_ctx.publicFeedbackEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox p-checkbox",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.user_allowed_public) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.user_allowed_public]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("tell_city_view.allow_public")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.something_wrong), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendFeedback && _ctx.sendFeedback(...args)), ["prevent"])),
          class: "defaultButton sendInfo"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("tell_city_view.submit_notification")) + " ", 1),
          _hoisted_32
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.showErrorDialog,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showErrorDialog) = $event)),
        class: "successDialog"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("feedback.invalid_image")), 1)
          ]),
          _createElementVNode("button", {
            class: "defaultButton",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showErrorDialog = false))
          }, _toDisplayString(_ctx.$t("dialog.close")), 1)
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}